import { motion } from "framer-motion";
import { Button } from "../ui/button";

export const BetaOffer = () => {
  const scrollToForm = () => {
    document.getElementById("join")?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <section
      data-testid="beta-offer-section"
      className="relative w-full px-4 py-24 sm:px-8 sm:py-32"
    >
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative mx-auto max-w-3xl overflow-hidden rounded-[40px] border border-slate-200/70 bg-slate-900 px-6 py-16 text-center shadow-[0_35px_80px_-25px_rgba(15,23,42,0.45)] sm:px-16"
      >
        <div className="absolute -top-24 left-1/2 h-64 w-64 -translate-x-1/2 rounded-full bg-sky-500/25 blur-3xl" />
        <span className="font-mono-accent relative z-10 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.25em] text-sky-300">
          Beta Release · Free Access
        </span>
        <h2 className="font-display relative z-10 mx-auto mt-6 max-w-xl text-3xl font-bold leading-tight text-white sm:text-4xl">
          Join the inner circle for our Beta Release.
        </h2>
        <p className="font-body relative z-10 mx-auto mt-4 max-w-lg text-base leading-relaxed text-slate-300 sm:text-lg">
          Early adopters get full access for FREE to test the web app before launch.
        </p>
        <Button
          data-testid="beta-offer-cta-button"
          onClick={scrollToForm}
          className="font-display relative z-10 mt-9 h-14 rounded-2xl bg-white px-8 text-base font-bold uppercase tracking-wide text-slate-900 shadow-[0_15px_35px_-10px_rgba(0,0,0,0.4)] transition-colors duration-200 hover:bg-sky-400 hover:text-white"
        >
          Join the Free Beta List
        </Button>
      </motion.div>
    </section>
  );
};
